export class AttributeAssignmentRow {
    public attributeId: number = null;
    public attributeName: string = null;
    public attributeValue: string = null;
    public attributeFormat: string = null;
}
